import {
  AI_SEARCH_TOKEN_DESER,
  AiSearchToken,
} from "../../tastyworks/ai-search-token"
import type HttpClient from "../../tastyworks/http"
import {
  parseSingleResponse,
  type SingleResponse,
} from "../../tastyworks/response"
import { INSTRUMENTS_API_HEADERS } from "./instruments"

export class AiSearchTokenService {
  constructor(private readonly instrumentsHttpClient: HttpClient) {}

  readonly getAiSearchToken = async (): Promise<
    SingleResponse<AiSearchToken>
  > => {
    const helper = await this.instrumentsHttpClient.postJson(
      "ai-search-token",
      {},
      undefined,
      INSTRUMENTS_API_HEADERS
    )
    return parseSingleResponse(
      helper,
      AI_SEARCH_TOKEN_DESER.toParser(AiSearchToken)
    )
  }
}
